<div class="tw-overflow-hidden tw-mb-3 tw-flex tw-items-center tw-justify-center tw-bg-gray-100 tw-relative tw-rounded-t-[18px]"
     [class]="size() === ProductSize.Medium ? 'tw-w-36 tw-h-[180px]' : 'tw-w-[120px] tw-h-[150px]'"
     [class.tw-mb-3]="!isShopRevampExperimentOn()"
     [class.tw-mb-2]="isShopRevampExperimentOn()"
     (click)="onGotoProduct(product())">
    @if (isLocked()) {
        <div class="tw-relative">
          <img class="tw-max-h-full tw-max-w-full" alt="{{ productTitle() }}" #productImageEl [src]="productImage()" />
          <div class="tw-absolute tw-inset-0 tw-bg-product-lock-overlay tw-backdrop-blur-[2px] tw-opacity-90 tw-z-[100] tw-flex tw-items-center tw-justify-center">
            <div class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-500 tw-rounded-full">
                <cs-icon class="tw-w-[14px] tw-h-[17px] tw-text-gray-500" [iconName]="'lock-icon-white'" />
            </div>
        </div>
        </div>
    } @else {
      <img class="tw-max-h-full tw-max-w-full"
           alt="{{ productTitle() }}"
           #productImageEl
           [src]="productImage()" />
    }
</div>
<h2 class="tw-flex-1 tw-font-lexend tw-font-medium tw-text-200 tw-mb-0.5 tw-w-[90%] tw-line-clamp-3"
    (click)="onGotoProduct(product())">
    {{ productTitle() }}
</h2>
@if (!isLocked()) {
    @if (isShopRevampExperimentOn()) {
        <div class="tw-mb-3 tw-flex tw-items-center tw-gap-1 tw-font-lexend"
             (click)="onGotoProduct(product())">
            <p class="tw-font-medium tw-text-200 tw-text-gray-500 tw-line-through">
                ₹{{ product()?.mrp }}
            </p>
            <p class="tw-font-bold tw-text-300 tw-text-orange-500">
                ₹{{ product()?.price }}
            </p>
        </div>
    } @else {
        <div class="tw-flex tw-gap-2 tw-mb-3 tw-font-lexend"
             (click)="onGotoProduct(product())">
            <p class="tw-font-bold tw-text-300 tw-line-through">
                ₹{{ product()?.mrp }}
            </p>
            <p class="tw-font-bold tw-text-300 tw-text-orange-500">
                ₹{{ product()?.price }}
            </p>
        </div>
    }

    @if (productQuantity() === 0) {
        <button csButton
                size="small"
                (click)="addToCartAction(product(), getProductImageElement())"
                class="tw-min-w-fit tw-w-fit tw-m-0"
                [class]="size() === ProductSize.Medium ? 'tw-px-4' : 'tw-px-[26px]'">
            @if (size() === ProductSize.Medium) {
              <span class="tw-text-300" i18n="@@addToCart">Add to Cart</span>
            } @else {
              <span class="tw-text-300" i18n="@@add">Add</span>
            }
        </button>
    } @else {
        <div [class]="size() === ProductSize.Medium ? 'tw-min-w-28 tw-justify-around' : ''"
            class="tw-h-8 tw-border tw-border-teal-600 tw-rounded-2 tw-flex tw-w-fit tw-items-center tw-text-300 tw-bg-white tw-text-teal-600 tw-font-lexend tw-font-semibold swiper-no-swiping">
            <div class="tw-px-[11.5px] tw-flex">
                <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'minus'" (click)="removeFromCartAction(product())"></cs-icon>
            </div>
            <span class="tw-px-1">{{ productQuantity() }}</span>
            <div class="tw-px-[11.5px] tw-flex">
                <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'plus'" (click)="addToCartAction(product(), getProductImageElement())"></cs-icon>
            </div>
        </div>
    }
}
